import { render, staticRenderFns } from "./BefPlatformInfo.vue?vue&type=template&id=3d83a00f&scoped=true"
import script from "./BefPlatformInfo.vue?vue&type=script&lang=js"
export * from "./BefPlatformInfo.vue?vue&type=script&lang=js"
import style0 from "./BefPlatformInfo.vue?vue&type=style&index=0&id=3d83a00f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d83a00f",
  null
  
)

export default component.exports